import Service from "../../services";
import Swal from "sweetalert2";

const knowledgesModule = {
  namespaced: true,
  state: {
    level_one_list: null,
  },
  mutations: {
    SET_LEVEL_ONE_LIST(state, data) {
      //data.image_url = JSON.parse(data.image_url)
      state.level_one_list = data;
    },
  },
  actions: {
    onGetLevelOne({ commit }) {
      return Service.KnowledgesAPI.getLevelOne().then((res) => {
        if (res.code == 200) {
          commit("SET_LEVEL_ONE_LIST", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
  },
};

export default knowledgesModule;
